module.exports = __webpack_public_path__ + "static/img/filter.93d7c31.gif";